import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.getColor('neutral-purewhite')};
    bottom: 0;
    flex: 0;
    order: 1;
    position: sticky;
    z-index: 2;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      bottom: initial;
      order: initial;
      position: relative;
    }
  `}
`

export const Content = styled.div`
  margin: 0 auto;
  max-width: 1366px;
  width: 100%;
`
